import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { BodyPrimary, H1, H2 } from '@liveauctioneers/hammer-ui-core/text';

type Props = {
    displayLocation: string;
    displaySearchTerm: string;
};

export const NoSearchResultsHeader = ({ displayLocation, displaySearchTerm }: Props) => {
    const { formatMessage } = useIntl();

    return (
        <div>
            <div className="mb-xl flex flex-col flex-wrap items-start gap-x-xs xsMax:flex-col xsMax:items-start">
                <H1>
                    {formatMessage({ id: 'searchPage.noResults.title' }, { searchTerm: displaySearchTerm })}
                    {displayLocation}
                </H1>
                <BodyPrimary>
                    {formatMessage({ id: 'searchPage.noResults.body' }, { searchTerm: displaySearchTerm })}
                </BodyPrimary>
            </div>

            <div className="pb-sm">
                <H2>{formatMessage({ id: 'searchPage.getNotified.title' })}</H2>
                <BodyPrimary>{formatMessage({ id: 'searchPage.getNotified.body' })}</BodyPrimary>
            </div>
        </div>
    );
};
